import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MaskedLinkButton } from "./MaskedLink.styles";
export var MaskedLink = function(param) {
    var body = param.body, href = param.href, target = param.target, title = param.title, className = param.className, onClick = param.onClick;
    if (!href) {
        return null;
    }
    var openLink = function(event) {
        if (typeof onClick === "function") {
            onClick(event);
        }
        if (target && target !== "_self") {
            window.open(href, target);
        } else {
            window.location.href = href;
        }
    };
    return /*#__PURE__*/ _jsx(MaskedLinkButton, {
        type: "button",
        onClick: openLink,
        title: title,
        className: className,
        children: body
    });
};
